import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  events: [],
  editingEvent: null,
  filter: "all",
};

const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    addEvent: (state, action) => {
      const id = state.events.length
        ? state.events[state.events.length - 1].id + 1
        : 1;
      state.events.push({ id, ...action.payload, visible: true });
    },
    editEvent: (state, action) => {
      const index = state.events.findIndex(
        (event) => event.id === action.payload.id
      );
      if (index !== -1) {
        state.events[index] = { ...state.events[index], ...action.payload };
      }
    },
    deleteEvent: (state, action) => {
      state.events = state.events.filter(
        (event) => event.id !== action.payload
      );
    },
    toggleVisibility: (state, action) => {
      const index = state.events.findIndex(
        (event) => event.id === action.payload
      );
      if (index !== -1) {
        state.events[index].visible = !state.events[index].visible;
      }
    },
    setEditingEvent: (state, action) => {
      state.editingEvent = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
  },
});

export const {
  addEvent,
  editEvent,
  deleteEvent,
  toggleVisibility,
  setEditingEvent,
  setFilter,
} = eventsSlice.actions;

export default eventsSlice.reducer;
